module.exports = __webpack_public_path__ + "static/media/categoriaHombre.b716e194.png";